import { render, staticRenderFns } from "./BuyFreeca.vue?vue&type=template&id=588583f3&scoped=true"
import script from "./BuyFreeca.vue?vue&type=script&lang=js"
export * from "./BuyFreeca.vue?vue&type=script&lang=js"
import style0 from "./BuyFreeca.vue?vue&type=style&index=0&id=588583f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588583f3",
  null
  
)

export default component.exports